const durationToSeconds = (duration) => {
  return duration.split(':').reduce((acc, time) => 60 * acc + +time);
};

module.exports = { durationToSeconds };
